import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { PropertyFilterGroup } from '../../model/property-type-group.model';
import { CheckboxListFilter } from '../checkbox-list-filter';
import { FormBuilder } from '@angular/forms';
import { HomeSearchFiltersAnalyticsHandler } from '../../home-search-filters-analytics-handler';
import {
  ALLOTMENT_TYPE,
  APARTMENT_TYPE,
  CORPORATE_SLABS_TYPE,
  FLAT_TYPE, HALL_TYPE,
  HOTEL_TYPE,
  HOUSE_TYPE, MALL_TYPE, PARKING_TYPE, ROOM_TYPE, RURAL_TYPE,
  SHED_TYPE, TERRAIN_TYPE
} from '../../const/property-type';
import { toKebabCase } from 'src/app/core/helpers/string.healper';

@Component({
  selector: 'lps-property-type-filter',
  templateUrl: './property-type-filter.component.html'
})
export class PropertyTypeFilterComponent extends CheckboxListFilter implements OnInit, OnChanges {

  public filters: any[] = [
    {
      groupName: 'Casa',
      options: HOUSE_TYPE
    },
    {
      groupName: 'Apartamento',
      options: APARTMENT_TYPE
    },
    {
      groupName: 'Flat',
      options: FLAT_TYPE
    },
    {
      groupName: 'Galpão',
      options: SHED_TYPE
    },
    {
      groupName: 'Hotel',
      options: HOTEL_TYPE
    },
    {
      groupName: 'Lajes corporativas',
      options: CORPORATE_SLABS_TYPE
    },
    {
      groupName: 'Loteamento',
      options: ALLOTMENT_TYPE
    },
    {
      groupName: 'Mall',
      options: MALL_TYPE
    },
    {
      groupName: 'Rural',
      options: RURAL_TYPE
    },
    {
      groupName: 'Salão',
      options: HALL_TYPE
    },
    {
      groupName: 'Salas',
      options: ROOM_TYPE
    },
    {
      groupName: 'Terreno',
      options: TERRAIN_TYPE
    },
    {
      groupName: 'Vagas',
      options: PARKING_TYPE
    }
  ].map(v => ({...v, options: v.options.map(o => ({...o, value: toKebabCase(o.value)}))}));

  @Input() propertyFilters: PropertyFilterGroup[];

  constructor( fb: FormBuilder, googleAnalyticsEventManager: HomeSearchFiltersAnalyticsHandler) {
    super(fb, googleAnalyticsEventManager);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.propertyFilters && changes.propertyFilters.isFirstChange()) {
      this.setFilters(this.propertyFilters);
    }
  }

  setFilters(propertyFilters) {
    this.filters = propertyFilters.map(v => ({ ...v, options: v.options.map(o => ({ ...o, value: toKebabCase(o.value) })) }));
  }

}
